import * as angular from 'angular';
import * as _ from 'lodash';
import * as $ from 'jquery';
import * as moment from 'moment';

import { ComponentDefinition, DateRange } from '../../models/';
import { IUserService, ILoggerService, IAuthenticationService } from '../../services/';
import { rangeSelected } from '../../common/';
import { Helper } from '../../common/helpers';

class SavedDatesController implements angular.IComponentController {
    savedDates: DateRange[];
    canNavigate: boolean;
    componentGuid: string;
    dates: {
        startDate: moment.Moment;
        endDate: moment.Moment;
    };
    selectedRange: DateRange;

    readonly format: string;

    private _data: DateRange;
    private _userName: string;

    static $inject = [
        '$rootScope',
        'authenticationService',
        'userService',
        'translatedLoggerService'
    ];
    constructor(
        private _$rootScope: angular.IRootScopeService,
        private _authenticationService: IAuthenticationService,
        private _userService: IUserService,
        private _loggerService: ILoggerService
    ) {
    }

    $onInit() {
        if (!this.componentGuid) {
            this.componentGuid = Helper.getGuid();
        }
        this._userName = this._authenticationService.authentication.userName;
        this.getSavedDates(this._userName);
    }

    private getSavedDates(userName) {
        this._userService
            .getSavedDatesForUser(userName)
            .then((payload) => {
                this.savedDates = payload.savedDates;
            })
            .catch((reason) => {
                this._loggerService.logError(reason, false);
            });
    }

    selectDate(range: DateRange): void {
        this._data = range;
        this._$rootScope.$broadcast(rangeSelected, range);
    }

    editButtonClick(range: DateRange, $event: angular.IAngularEvent) {
        this.selectedRange = range;
        $(`#saveDateModal${this.componentGuid}`).modal('show');
        if ($event) {
            $event.stopPropagation();
        }
    }

    deleteButtonClick(range: DateRange, $event: angular.IAngularEvent) {
        this.selectedRange = range;
        $(`#deleteRangeModal${this.componentGuid}`).modal('show');
        if ($event) {
            $event.stopPropagation();
        }
    }

    saveDate(range: DateRange) {
        const promise = range.guid
            ? this._userService.updateSavedDatesForUser(this._userName, range)
            : this._userService.addSavedDatesForUser(this._userName, range);
        return promise
            .then(payload => {
                this._loggerService.logSuccess('Range successfully saved.');
                this.getSavedDates(this._userName);
                this.selectedRange = null;
            })
            .catch(reason => this._loggerService.logError('Failed to save range.'))
            .finally(() => this.selectedRange = null);
    }

    onCancel() {
        this.selectedRange = null;
    }

    deleteRange(item: DateRange) {
        this._userService
            .deleteSavedDatesForUser(this._userName, item.guid)
            .then(payload => {
                this._loggerService.logSuccess('Range successfully deleted.');
                return this.getSavedDates(this._userName);
            })
            .catch(() => this._loggerService.logError('Failed to delete range.'))
            .finally(() => this.selectedRange = null);
    }
}

export const wtSavedDates: ComponentDefinition = {
    componentId: 'wtSavedDates',
    controller: SavedDatesController,
    template: require('./savedDates.component.html'),
    controllerAs: 'vm',
    bindings: {
        canNavigate: '=',
        componentGuid: '<?',
        dates: '=',
        format: '<',
        modalEmbedded: '<?',
        timezone: '=?',
    }
};